import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import storePersist from '../../../../redux/storePersist';
import PageLoader from '../../../../components/PageLoader';
import { selectnexusARecordsQueryItems } from '../../../../redux/nexus-a-records/selector';
import { nexusARecords } from '../../../../redux/nexus-a-records/action';
import NexusARecordComponent from '../components/nexus-a-record.component';
import { nexusARecordTypes } from '../../../../redux/nexus-a-record-types/action';
import { selectnexusARecordTypesListItems } from '../../../../redux/nexus-a-record-types/selector';
import { selectAccountTypesListItems } from '../../../../redux/account-types/selector';
import { selectAccountsListItems } from '../../../../redux/accounts/selector';
import { selectListItems } from '../../../../redux/library/selector';
import { accountTypes } from '../../../../redux/account-types/action';
import { accounts } from '../../../../redux/accounts/action';
import { ListCriteria } from '../../types/list-criteria';
import { templates } from '../../../../redux/templates/action';
import { selectTemplatesListItems } from '../../../../redux/templates/selector';

const ManagementNexusARecord = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const nexusARecordsQuery = useSelector(selectnexusARecordsQueryItems)
    const librariesItems = storePersist?.get("library")?.current;
    const nexusARecordTypeListItems = useSelector(selectnexusARecordTypesListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [selectedNexusARecords, setSelectedNexusARecords] = useState<any>([])
    const [accountTypesList, setAccountTypesList] = useState<any>([]);
    const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
    const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
    const accountItems = useSelector(selectAccountsListItems)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const libraryData = useSelector(selectListItems)
    const [accountsList, setAccountsList] = useState<any>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const TypeData = libraryData?.result?.Type
    const templateListis = useSelector(selectTemplatesListItems)




    const listAccountTypes = async () => {
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBAAccountTypes = async () => {
        // v6.1/organization/dbn/dba-type-dba-mappings
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBNBizAccountTypes = async () => {
        // v6.1/organization/dbn/biz-net-types
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
        await dispatch(accounts.resetAction({ actionType: 'list' }))
        await dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
            entity: 'accounts',
            jsonData: {
                "Filters": filterCriteria,
                "Searches": searchCriteria,
                "DateCriteria": dateCriteria,
            }
        }))
    }

    const fetchNexusARecordsQueryById = () => {
        dispatch(nexusARecords.query({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-records/query`,
            entity: 'nexusARecords',
            jsonData: {
                Records: [
                    {
                        Context: {},
                        Message: {
                            Id: parmas?.id
                        }
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedNexusARecords({ ...selectedNexusARecords, [field]: event })
    }

    useEffect(
        () => {
            dispatch(nexusARecordTypes.list({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types/list`,
                entity: 'NexusARecordTypes',
                jsonData: {}
            }))
                .then(() => {

                    dispatch(templates.list({
                        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/list`,
                        entity: 'templates',
                        jsonData: {}
                    }))
                })
                .then(() => {
                    if (parmas?.id > 0) {
                        fetchNexusARecordsQueryById()
                        setIsLoading(false)
                    } else {
                        setIsLoading(false)
                    }
                })
        }, []
    )

    useEffect(() => {
        if (isQuery) {
            setSelectedNexusARecords(nexusARecordsQuery?.result?.items?.Message)
        }
    }, [isQuery]
    )


    useEffect(() => {
        setAssociatedAccountTypeId(selectedNexusARecords?.OwnerTypeId);
        setOwnerLevelId(selectedNexusARecords?.OwnerLevelId);
    }, [selectedNexusARecords]);

    useEffect(() => {
        if (associatedAccountTypeId && accountTypesList) {
            const accountTypeName = accountTypesList?.find(
                (item: any) => item.Id === associatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                (type: any) => type.Text === accountTypeName
            )?.Text;
            if (accountTypeValue) {
                listAccountsByType({
                    filterCriteria: [{
                        "FieldName": "Type",
                        "FilterOperatorId": 6,
                        "FieldValue": accountTypeValue,
                        "FieldType": "text"
                    }]
                })
            }
        }
    }, [accountTypesList, associatedAccountTypeId]);



    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                listAccountTypes();
                break;
            case 11:
                listDBAAccountTypes();
                break;
            case 12:
                listDBNBizAccountTypes();
                break;
            default:
                dispatch(accountTypes.resetAction({ actionType: 'list' }))
                break;

        }
    }, [ownerLevelId]);

    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                setAccountTypesList(accountTypeItems?.result?.items);
                setAccountsList([]);
                break;
            case 11:
                setAccountTypesList(accountTypeItems?.result?.items?.map((o: { Id: any; Name: any; }) => { return { Id: o?.Id, Name: o?.Name } }));
                setAccountsList([]);
                break;
            case 12:
                setAccountTypesList(accountTypeItems?.result?.items?.map((o: { IEAccountTypeId: any; IEAccountTypeName: any; }) => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
                setAccountsList([]);
                break;
            default:
                setAccountTypesList([]);
                setAccountsList([]);
                break;

        }
    }, [accountTypeItems]);

    useEffect(() => {
        dispatch(accounts.resetAction({ actionType: 'list' }))
        setAccountsList([])
    }, []);

    useEffect(() => {
        setAccountsList(accountItems?.result?.items || [])
    }, [accountItems]);

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(nexusARecords.resetAction({ actionType: 'update' }))
            await dispatch(nexusARecords.update({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-records`,
                entity: 'nexusARecords',
                jsonData: {
                    Records: [
                        {
                            Context: {},
                            Message:
                                selectedNexusARecords
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(nexusARecords.resetAction({ actionType: 'create' }))
            await dispatch(nexusARecords.create({
                url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-records`,
                entity: 'nexusARecords',
                jsonData: {
                    Records: [
                        {
                            Context: {},
                            Message:
                                selectedNexusARecords
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/nexus/nexus-management/nexus-a-records')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <NexusARecordComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedNexusARecords={selectedNexusARecords}
                    entityTypeList={librariesItems?.EntityTypes}
                    nexusARecordTypeList={nexusARecordTypeListItems?.result?.items}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    accountTypesListLoading={accountTypeItems?.isLoading}
                    accountTypesList={accountTypesList}
                    accountListLoading={accountItems?.isLoading}
                    accountsList={accountsList}
                    isLoading={isLoading}
                    PolicyOwnerType={libraryData?.result?.PolicyOwnerType}
                    TemplateGroupEntityType={libraryData?.result?.TemplateGroupEntityType}
                    templates={templateListis?.result?.items}


                />
            }
        </>
    )
}

export default ManagementNexusARecord;